module.exports = __webpack_public_path__ + "img/facebook.bcaf0caf.svg";